import React, { useState } from "react";
import './NeuroaTooltip.css';

const NeuroaTooltip = ({ text, children, forceShow = false, position = "top" }) => {
  const [isHovered, setIsHovered] = useState(false);

  // Show if either hovered OR forced externally
  const isVisible = isHovered || forceShow;

  return (
    <div 
      className="neuroa-tooltip-container" 
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {isVisible && (
        <div className={`neuroa-custom-tooltip fade-in ${position === 'right' ? 'position-right' : ''}`}>
          {text}
          <div className="neuroa-tooltip-arrow" />
        </div>
      )}
      {children}
    </div>
  );
};

export default NeuroaTooltip;